// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/OdooTickets_ListTicketsInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for GET /odoo_tickets/list_tickets
 *
 * Pagination params for listing support tickets.
 */
import { registerContract } from './validate'

export interface OdooTickets_ListTicketsInput {
limit?: number
offset?: number
}

registerContract('OdooTickets_ListTicketsInput', {
  limit:  { type: 'number',  required: false },
  offset: { type: 'number',  required: false },
})
